import { Typography } from '@mui/material';
import { FC } from 'react';

interface IProps {
	children: React.ReactNode;
}

const PageTitle: FC<IProps> = ({ children }) => (
	<Typography
		variant='h4'
		sx={(theme) => ({
			color: 'secondary.main',
			mr: 'auto',
			[theme.breakpoints.down('md')]: {
				width: '100%',
			},
			padding: '1rem',
			margin: 'auto',
			textAlign: 'center',
		})}
	>
		{children}
	</Typography>
);

export default PageTitle;
